<template>
  <div class="auth-header-wrap">
    <ul class="auth-header">
      <li class="logo-wrap auth-header-item">
          <logo-icon></logo-icon>
        <!--<img src="@/assets/logo.svg" alt="Logo" class="logo" style="height: 40px;" />-->
        <span class="logo-text">ARINET SPACE</span>
      </li>
      <li class="auth-header-item flex-item">
        <router-link :to="{ name: 'About' }">
          <a>{{$t('menu.aboutProject')}}</a>
        </router-link>
      </li>
      <li class="auth-header-item flex-item">
        <a>{{$t('menu.cooperation')}}</a>
      </li>
      <li class="auth-header-item flex-item">
        <a>{{$t('menu.FAQ')}}</a>
      </li>
      <li class="auth-header-item spacer"></li>
      <li class="auth-header-item enter">
        <router-link :to="{ name: 'Login' }" style=" text-decoration: none;">
          <icon-enter
            style="position:absolute; left:15px;  cursor:pointer;"
            :width="18"
            :height="18"
            :color="'#fff'"
          />
          <a style="padding-left: 10px; color: white !important;">{{ $t('authorization.signIn') }}</a>
        </router-link>
      </li>
      <li class="auth-header-item lang">
        <language-with-icon />
      </li>
      <!--<li class="auth-header-item">
        <theme-switch></theme-switch>
      </li>-->
    </ul>
  </div>
</template>

<script>
import iconEnter from "@/components/icons/iconEnter.vue";
import LanguageWithIcon from "../languageWithIcon";
import ThemeSwitch from '../themeSwitch';
import LogoIcon from '@/components/icons/navbarIcon/LogoIcon.vue';
export default {
  components: {
    LogoIcon,
    ThemeSwitch,
    LanguageWithIcon,
    "icon-enter": iconEnter,
  },
};
</script>


<style scoped lang="scss">
.auth-header-wrap .auth-header li {
  display: flex;
  list-style: none;
  align-items: center;
  justify-content: center;
  height: inherit;
  box-sizing: border-box;
}

.auth-header-wrap .auth-header li a {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: var(--textGeneralColor);
  flex: none;
  order: 0;
  padding: 0px;
  cursor: pointer;
  text-decoration: none;
}
.flex-item {
  flex-grow: 1;
}
.auth-header-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
.auth-header {
  background-color: var(--backgroundColor);
  margin: 0 auto;
  width: 1200px;
  list-style-type: none;
  justify-content: space-around;
  display: flex;
  height: 65px;
  padding: 0;
  box-shadow: 0px 4px 4px var(--box-shadow);
  border-radius: 0px 0px 5px 5px;
}
.auth-header-item {
  padding-left: 0px;
  padding-right: 0px;
}
li a:hover {
  color: var(--textBlueButton) !important;
}
.auth-header {
  padding-left: 25px;
}
.auth-header .spacer {
  flex-grow: 2;
}
.auth-header .logo-wrap {
  width: 160px !important;
  margin-right: 50px;
}
.auth-header .logo-wrap .logo {
  // height: 39px;
  // width: 46px;
  margin-right: 5px;
}
.auth-header .logo-wrap .logo-text {
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: var(--textGeneralColor);
}
.lang {
  width: 21px !important;
  padding-left: 25px !important;
  padding-right: 25px !important;
  border-left: 1px solid var(--greyBorder);
  box-sizing: unset !important;
}
.enter {
  position: relative;
  width: 120px;
  padding-left: 10px !important;
  padding-right: 30px !important;
  width: 105px;
  padding-left: 20px !important;
  padding-right: 10px !important;
  margin-right: 20px !important;
  background: #006eff;
  border-radius: 5px;
  height: 39px !important;
  margin-top: 10px !important;
}
.enter a:hover {
  color:var(--whiteText) !important;
}
.enter:hover {
  background: #005dd8;
  cursor: pointer;
}
</style>
